import React, { useState, useEffect } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { Font } from "@react-pdf/renderer";
import fontBold from "./fonts/NotoSansTamil-Bold.ttf";
import fontRegular from "./fonts/NotoSansTamil-Regular.ttf";
import { BsTransparency } from "react-icons/bs";

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

Font.register({
  family: "fontBold",
  fonts: [{ src: fontBold, fontStyle: "normal", fontWeight: "bold" }],
});
Font.register({
  family: "fontRegular",
  fonts: [{ src: fontRegular, fontStyle: "normal", fontWeight: "normal" }],
});

const styles = StyleSheet.create({
  normalText: {
    fontFamily: "fontRegular",
    fontWeight: "normal",
  },
  boldText: {
    fontFamily: "fontBold",
    fontWeight: "bold",
  },
  page: {
    flexDirection: "column",
    backgroundColor: "#fff",
    padding: 0,
  },
  imageContainer: {
    flexDirection: "column",
    padding: 10,
    alignItems: "center",
    width: "100%",
  },
  imageRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 5, // Space between rows
  },
  imageWrapper: {
    width: "45%",
    height: 120,
    marginHorizontal: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  proofImage: {
    width: 120,
    height: 120,
    objectFit: "contain",
  },
  emptyImagePlaceholder: {
    width: 120,
    height: 120,
    borderWidth: 1,
    borderColor: "#4535C1",
    backgroundColor: "#f0f0f0",
  },

  header: {
    fontFamily: "fontRegular",
    fontSize: 8,
  },
  section: {
    margin: 15,
    flexGrow: 1,
    border: 1,
    padding: 0,
    letterSpacing: 1,
    borderColor: "#4535C1",
    color: "#4535C1",
  },
  dupe: {
    margin: 15,
    flexGrow: 1,
    border: 1,
    padding: 0,
    borderColor: "#4535C1",
    letterSpacing: 1,
    color: "#4535C1",
  },
  godtitle: {
    fontSize: 8,
    padding: 5,
    textAlign: "center",
  },
  godtitles: {
    position: "absolute",
    justifyContent: "start",
    alignItems: "start",
    textAlign: "start",
    right: 140,
    bottom: 50,
    top: 1,
    left: 300,
    padding: 10,
    color: "#4535C1",
    fontSize: 70,
    fontWeight: "bold",
  },
  font: {
    fontFamily: "fontRegular",
  },
  red: {
    color: "red",
  },
  storename: {
    textAlign: "center",
    fontFamily: "fontBold",
    fontSize: 11,
    letterSpacing: 1,
    fontWeight: "bold",
  },
  table: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    width: "100%",
    borderBottom: 1,
    borderTop: 1,
    fontSize: 9,
    borderColor: "#4535C1",
  },
  border_bottom: {
    width: "100%",
    borderTop: 1,
    borderColor: "#4535C1",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableRow1: {
    flexDirection: "row",
    paddingLeft: "90px",
  },
  company: {
    width: "50%",
    padding: 6,
    fontFamily: "fontRegular",
    textAlign: "center",
    fontSize: 9,
  },
  tableCell: {
    width: "30%",
    padding: 7,
    fontSize: 8.5,
  },
  dateCell: {
    width: "50%",
    padding: 7,
    fontSize: 8.5,
  },
  pad: {
    paddingVertical: 3,
  },
  tab: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 10,
    fontSize: 8,
  },
  pawnAmt: {
    textAlign: "right",
  },
  customerdetail: {
    paddingHorizontal: 7,
    display: "flex",
    fontSize: 7.5,
  },
  details1: {
    paddingVertical: 6,
    display: "flex",
    flexDirection: "row",
  },
  details: {
    paddingVertical: 6,
    flexDirection: "row",
  },
  details2: {
    flexDirection: "row",
    fontSize: 7.6,
  },
  state: {
    width: "33.5%",
    fontFamily: "fontBold",
    fontWeight: "bold",
  },
  customtab: {
    display: "flex",
    fontFamily: "fontRegular",
    flexDirection: "row",
    paddingVertical: 4,
  },
  jewelprice: {
    paddingVertical: 10,
  },
  row: {
    flexDirection: "row",
    marginBottom: 5,
  },
  footer: {
    display: "table",
    fontFamily: "fontRegular",
    flexDirection: "row",
    padding: 6,
    paddingTop: 50,
    color: "#4535C1",
  },
  time: {
    width: "30%",
    padding: 5,
    border: 1,
    marginHorizontal: 1,
    borderRadius: 8,
    fontSize: 8,
    borderColor: "#4535C1",
  },
  footerdesc: {
    padding: 12,
    border: 1,
    marginHorizontal: 3,
    borderRadius: 8,
    fontSize: 8,
    paddingHorizontal: 10,
    width: "70%",
    borderColor: "#4535C1",
  },
  origialdesc: {
    width: "100%",
    padding: 12,
    border: 1,
    marginHorizontal: 2,
    borderRadius: 8,
    fontSize: 8,
    borderColor: "#4535C1",
  },
  phone: {
    width: "30%",
    padding: 8,
    border: 1,
    margin: "0 auto",
    marginHorizontal: 2,
    fontSize: 8,
    fontFamily: "fontRegular",
    borderRadius: 8,
    borderColor: "#4535C1",
  },
  ph: {
    marginVertical: 10,
  },
  none: {
    display: "none",
  },
  line: {
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    color: "#4535C1",
    marginTop: 0,
  },
  termsTitle: {
    fontSize: 10,
    fontFamily: "fontRegular",
  },
  termlist: {
    fontSize: 9,
    paddingHorizontal: 22,
  },
  termpoint: {
    paddingVertical: 4,
  },
  billcreate: {
    fontSize: 8,
  },
  padmac: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    right: 40,
    bottom: 15,
    padding: 15,
    fontSize: 12,
    fontWeight: "bold",
  },
  paidStamp: {
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    right: 15,
    bottom: 50,
    padding: 10,
    borderWidth: 2,
    borderColor: "#4535C1",
    borderRadius: 5,
    color: "#4535C1",
    fontSize: 20,
    fontWeight: "bold",
  },
  paidText: {
    color: "#4535C1",
    fontSize: 20,
    fontWeight: "bold",
  },
  divider: {
    width: "100%",
    height: 1.5,
    backgroundColor: "#4535C1",
    marginVertical: 5,
  },
  dateText: {
    color: "#C40C0C",
    fontSize: 14,
    fontWeight: "bold",
  },
  tableContent: {
    marginVertical: "550px",
    margin: 8,
    flexGrow: 1,
    border: 1,
    padding: 0,
    letterSpacing: 1,
    borderColor: "#4535C1",
  },
});

const JewelPawnPdf = ({ data }) => {
  const [user, setUser] = useState([]);
  console.log("pdfdata", data);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  

  

  const formattedDate = formatDate(data.pawnjewelry_date);

  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.page}>
        <View style={styles.dupe}>
          <View style={styles.font}>
            <View style={styles.godtitle}>
              <Text>உ</Text>
              <Text>ஸ்ரீ அய்யனார் துணை</Text>
              <Text>ஸ்ரீ பாண்டி முனியாண்டி துணை</Text>
              <Text>ஸ்ரீ சக்தி துணை </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableRow}>
                <View style={styles.tableCell}>
                  {/* <Text style={styles.pad}>
                    <Text style={styles.boldText}>ரசீது எண்: </Text>
                    <Text style={styles.red}>{data.recipt_no}</Text>
                  </Text> */}{" "}
                  <Text style={styles.pad}>
                    <Text style={styles.boldText}>உரிம எண்:</Text>
                    <Text style={styles.normalText}>3/2014-2015</Text>
                  </Text>
                  <Text style={styles.normalText}>பா.பாண்டி</Text>
                </View>
              </View>
              <View style={styles.tableRow}>
                <View style={styles.company}>
                  <Text style={styles.storename}>ஸ்ரீ தேவி பைனான்ஸ்</Text>
                  <Text> {""}</Text>
                  <Text style={styles.storename}>நகை அடகு கடை</Text>
                  <Text> {""}</Text>
                  <Text>
                    7, அனந்தன் தெரு, உசிலைரோடு,(சபரி கேஸ் ஏஜென்சி எதிர் சந்து)
                    திருமங்கலம்.
                  </Text>
                  <Text> {""}</Text>
                  <Text style={styles.boldText}>
                    எங்களிடம் தங்கம்,வெள்ளி நகைகள் அனைத்தும் நல்ல விலைக்கு
                    வாங்க, விற்க அணுகவும்{" "}
                  </Text>
                  <Text> </Text>
                </View>
              </View>
              <View style={styles.tableRow1}>
                <View style={styles.dateCell}>
                  <Text style={styles.pad}>
                    {/* <Text style={styles.boldText}>அடகு ரூ : </Text>
                    <Text style={styles.normalText}>
                      {data.original_amount}
                    </Text> */}
                  </Text>
                  <Text style={styles.pad}>
                    <Text style={styles.boldText}>அடகு தேதி : </Text>
                    <Text style={styles.normalText}>{formattedDate}</Text>
                  </Text>
                </View>
              </View>
            </View>

            <View style={styles.tab}>
              <View>
                <Text>
                  அடியிற்கண்ட பொருட்கள் எங்களிடம் அடகு வைக்கப்பட்டு உள்ளது{" "}
                  <View style={styles.none}>உள்ளது உள்ளது</View>{" "}
                </Text>
              </View>
            </View>
            <View style={styles.customerdetail}>
              <View style={styles.details}>
                <Text style={styles.state}>1.அடகு எண் : </Text>
                <Text> {data.receipt_no} </Text>
              </View>
              <View style={styles.details}>
                <Text style={styles.state}>
                  2.அடகு வைப்பவர் பெயர் மற்றும் விலாசம் :{" "}
                </Text>
                <Text> {data.customer_details} </Text>
              </View>
              {/* <View style={styles.details}>
                <Text style={styles.state}>2.தகப்பனார்/ கணவர் :</Text>
                <Text> {data.name_of_guardians} </Text>
              </View>
              <View style={styles.details}>
                <Text style={styles.state}>3.விலாசம் :</Text>
                <Text> {data.address} </Text>
              </View> */}{" "}
              {data.mobile_number != "" ? (
                <View style={styles.details}>
                  <Text style={styles.state}>3.தொலைபேசி எண்:</Text>
                  <Text> {data.mobile_number} </Text>
                </View>
              ) : (
                ""
              )}
              <View style={styles.details}>
                <Text style={styles.state}>
                  {data.mobile_number != "" ? "4" : "3"}.அடகு ரூபாய் :
                </Text>
                <Text> {data.original_amount} </Text>
              </View>
              <View style={styles.details}>
                <Text style={styles.state}>
                  {data.mobile_number != "" ? "5" : "4"}.அடகு பொருளின் விபரம்{" "}
                  <View style={styles.none}>ம்</View> :{" "}
                </Text>
                <Text>{data.pledged_items} </Text>
              </View>
              <View style={styles.details}>
                <Text style={styles.state}>
                  {data.mobile_number != "" ? "6" : "5"}.உருப்படி :{" "}
                </Text>
                <Text>{data.item} எண்ணம் மட்டும்</Text>
              </View>
              <View style={styles.details}>
                <Text style={styles.state}>
                  {data.mobile_number != "" ? "7" : "6"}.நகை மொத்த எடை :{" "}
                </Text>
                <Text>{data.total_weight} கிராம் மட்டும்</Text>
              </View>
              <View style={styles.details}>
                <Text style={styles.state}>
                  {data.mobile_number != "" ? "8" : "7"}.நகை மீட்பு ஒப்புக்கொண்ட
                  காலம் :
                </Text>
                <Text>{data.Jewelry_recovery_agreed_period} </Text>
              </View>
              {/* <View style={styles.details}>
                <Text style={styles.boldText}>
                  {data.mobile_number !== "" ? "8" : "7"}.
                  <Text style={styles.boldText}>சுமார் மதிப்பு ரூ. :</Text>
                </Text>
                <Text style={styles.normalText}>
                  {" "}
                  {data.jewel_original_rate} ,{"       "}
                </Text>
                <Text style={styles.boldText}>
                  {data.mobile_number !== "" ? "9" : "8"}.
                  <Text style={styles.boldText}>
                    நகை மீட்க ஒப்புகொண்ட தேதி{" "}
                  </Text>
                </Text>
                <Text style={styles.normalText}>
                  {" "}
                  : {formattedDaterecovery}{" "}
                </Text>
              </View> */}{" "}
              <View>
                <View style={styles.details}>
                  <Text style={styles.boldText}>
                    {data.mobile_number !== "" ? "9" : "8"}. அடகு வைப்பவரின்
                    கையெழுத்து அல்லது அவருடைய ஏஜென்ட் கையெழுத்து :
                  </Text>
                  <Text style={styles.normalText}>
                    {"  "}
                    {data.createdby !== "" && data.createdby !== null
                      ? data.createdby
                      : "A.R"}
                  </Text>
                </View>
              </View>
              {/* <View style={styles.godtitles}>
                <Text>D </Text>
              </View> */}
              {/* {data.paidby ? (
                <>
                  <View style={styles.paidStamp}>
                    <Text style={styles.paidText}>PAID</Text>
                    <View style={styles.divider} />
                    <Text style={styles.dateText}>{formattedDaterecovery}</Text>
                  </View>
                  <View style={styles.padmac}>
                    <Text style={styles.dateText}>
                      {data.createdby !== "" && data.createdby !== null
                        ? data.createdby
                        : "A.R"}
                    </Text>
                  </View>
                </>
              ) : null} */}{" "}
            </View>

            {/* <View style={styles.details2}>
              <Text style={styles.boldText}> Bill Create : </Text>
              <Text style={styles.normalText}>
                {"  "}
                {data.createdby !== "" && data.createdby !== null
                  ? data.createdby
                  : "A.R"}
              </Text>
            </View> */}

            {/* இமேஜ்கள் இங்கு சேர்க்கப்படுகின்றன */}
            {data.proof && data.proof.length > 0 && (
  <View style={[styles.imageContainer, styles.border_bottom]}>
    {/* Top Row */}
    <View style={styles.imageRow}>
      {[0, 1].map((index) => (
        <View key={`top-${index}`} style={styles.imageWrapper}>
          {data.proof[index] ? (
            <Image style={styles.proofImage} src={data.proof[index]} />
          ) : (
            <View style={styles.emptyImagePlaceholder} />
          )}
        </View>
      ))}
    </View>
    {/* Bottom Row */}
    <View style={styles.imageRow}>
      {[2, 3].map((index) => (
        <View key={`bottom-${index}`} style={styles.imageWrapper}>
          {data.proof[index] ? (
            <Image style={styles.proofImage} src={data.proof[index]} />
          ) : (
            <View style={styles.emptyImagePlaceholder} />
          )}
        </View>
      ))}
    </View>
  </View>
)}

            <View style={styles.footer}>
              <View style={styles.time}>
                <Text style={styles.boldText}>வேலை நேரம்</Text>
                <Text style={styles.termpoint}>
                  காலை 9.00 மணி முதல் இரவு 8.00 மணி வரை
                </Text>
              </View>

              <View style={styles.footerdesc}>
                <Text>
                  6 மாதத்திற்குள் திருப்பவும் அல்லது வட்டி கட்டி புதுப்பிக்கவும்{" "}
                </Text>
                {/* <Text>
                  {" "}
                  <Text style={styles.line}>
                    {" "}
                    ______________________________
                  </Text>{" "}
                  வசம் ஒப்படைக்கவும் <View style={styles.none}>ம்</View>
                </Text> */}
                {/* <View style={styles.line}>
                  <Text>அடகு வைத்தவர் கையெழுத்து</Text>
                </View> */}{" "}
              </View>
              <View style={styles.phone}>
                <View style={styles.termpoint}>
                  <Text style={styles.boldText}>தொடர்புக்கு </Text>
                  <Text style={styles.termpoint}>
                    <Text style={styles.boldText}>கடை :</Text> 9940762856
                  </Text>
                  <Text> </Text>
                  <Text>
                    <Text style={styles.boldText}>செல் :</Text>9092085590
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default JewelPawnPdf;
